import styled, {css} from 'styled-components';

import {mixins} from '../styles';

export const Percent = styled.div`
  ${mixins.f8}
  color: ${({theme}) => theme.palette.black};
`;

interface IPercentSymbol {
  noMarginLeft?: boolean;
}

const getPercentSymbolStyle = ({noMarginLeft}: IPercentSymbol) => {
  if (noMarginLeft) {
    return '';
  }

  return css`
    margin-left: ${({theme}) => theme.spacing.s1};
  `;
};

export const PercentSymbol = styled.span<IPercentSymbol>`
  ${mixins.f5}
  opacity: 0.64;
  ${getPercentSymbolStyle}
`;
